export default "__VITE_PUBLIC_ASSET__f80a83b1__"